module.exports = __webpack_public_path__ + "img/icon_check_light.b7e6f7ed.svg";